interface ZoomButtonProps {
  upperText: string;
  lowerText: string;
  onClick?: () => void;
  selected?: boolean;
}

const ZoomButton: React.FC<ZoomButtonProps> = ({
  upperText,
  lowerText,
  onClick,
  selected = false,
}) => {
  return (
    <button
      onClick={onClick}
      className={`inline-flex flex-col p-3 justify-center items-start gap-1 md:gap-2 self-stretch rounded-lg ${selected ? "bg-white" : "bg-neutral-100/70 hover:bg-neutral-100"} ease-in-out duration-150 cursor-pointer`}
    >
      <p className="text-xs md:text-sm font-sans text-neutral-700 font-semibold overflow-ellipsis leading-3 md:leading-[14px] select-none">
        {upperText}
      </p>
      <p className="text-xs md:text-sm font-sans text-neutral-700 overflow-ellipsis leading-3 md:leading-[14px] select-none">
        {lowerText}
      </p>
    </button>
  );
};

export default ZoomButton;
